var exports = {
  "xE": "WarningAlert.module__alert___RTNLRV",
  "Kk": "WarningAlert.module__icon___RTNLRV",
  "Qs": "WarningAlert.module__content___RTNLRV",
  "DD": "WarningAlert.module__title___RTNLRV",
  "Qq": "WarningAlert.module__text___RTNLRV",
  "nf": "WarningAlert.module__link___RTNLRV",
  "o1": "WarningAlert.module__actions___RTNLRV",
};

module.exports = exports;
